/** @jsx jsx */

import React, { Fragment as _, useContext, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { interactionContext } from './interactionContext';
import { unlockInteraction } from 'services/unlockInteraction';

const { lGrey2 } = colors;

const ClickAndReveals = ({ children, ...props }) => {
  const context = useContext(interactionContext);
  const itemsSeen = useRef(
    unlockInteraction(context.id, (children as any).length)
  );

  context.updateClickAndRevealSeen = id => {
    if (context.props.lockDown === 0) {
      return;
    }
    itemsSeen.current(id);
  };

  // console.log(props.id);

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        width: 100%;
        // height: 100%;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          height: 100%;
          // space-around

          // > div {
          //   // margin: 20px 20px;
          //   margin: 5px;
          //   padding: 5px;
          //   transition: all 0.2s;
          // }
        `}
      >
        {children.map((child: any) => {
          return React.cloneElement(child, { parentId: props.id });
        })}
      </div>
    </div>
  );
};

export default ClickAndReveals;
